
import {Component, h, Prop, Element, Method} from '@stencil/core';
import { FacetTypeEnum, type FacetValueCose } from '../../../../api/model/response/facets/Facets';
import type { labelProviderInterface } from '../../../LabelProviderInterface';

@Component({
  tag: 'date-filter-facet-component',
  shadow: false
})
export class DateFilterFacet {
  @Element() el;
  @Prop({ mutable: true }) labelProvider?: labelProviderInterface;
  @Prop({ mutable: true }) facets: Array<FacetValueCose>;
  @Prop({ mutable: true }) validFacetValue = true;
  @Prop() readonly validFacetValueChanged: CallableFunction;

  componentWillLoad() {
      if (!this.labelProvider) {
        // console.log(
        //   'Assigning default labelProvider to SearchTable component'
        // );
        this.labelProvider = (name, fallback) => {
            // console.log(
            //   'LabelProvider not provided in SearchTable component',
            //   [name, fallback]
            // );
            return fallback;
        };
      }

  }

  render(): HTMLElement {
      return (<div>
        {this.facets.map(facet=> {
            let facetLabel = '';
            if(facet.displayName) {
              facetLabel = facet.displayName;
            }else{
              if(facet.type === FacetTypeEnum.DateStart){
                facetLabel = this.labelProvider('datefacet.startDate','Start date');
              }
              if(facet.type === FacetTypeEnum.DateEnd){
                facetLabel = this.labelProvider('datefacet.endDate','End date');
              }
            }
            return(<span>
              {facetLabel ?
                <label
                  class={`date-facet-input-label${facet.type === FacetTypeEnum.DateEnd ? '-end-date' : ''}`}
                >{facetLabel}</label> : ''}
              <input
                required
                id="date-facet-input"
                type="date"
                value={facet.value}
                class={`date-facet-input${(!this.validFacetValue && facet.type === FacetTypeEnum.DateEnd) ? '-error' : ''}`}
                onInput={(e) => this.dateInpuChanged((e.currentTarget as HTMLInputElement).value, facet.type)}
              />
              {(!this.validFacetValue && facet.type === FacetTypeEnum.DateEnd) ? <span id='datePickerValidationError' class="date-facet-input-validation-error">{this.labelProvider('datefacet.endDateLessThanDateFromVadliationMessage','The end date cannnot be earlier than start date')}</span> : '' }</span>);
        })}
      </div>);
  }

  @Method()
  async dateInpuChanged(val, type): Promise<void>
  {
      const updatedFacets = this.facets.map(facet=> {
          if(facet.type === type){
            facet.value = val;
          }
          return facet;
      });
      this.facets = [...updatedFacets];
      const dateFrom = Date.parse(this.facets[0].value);
      const dateTo = Date.parse(this.facets[1].value);
      if(dateTo < dateFrom){
        this.validFacetValue = false;
        return;
      }else{
        this.validFacetValue = true;
        this.validFacetValueChanged(val, type);
      }
  }
}
